import m from 'mithril';
import {trans} from "./helpers";

let chooser_state = {
    // is_admin : SPORTNETXPAGE.USER && SPORTNETXPAGE.USER.roles.includes("Fit Admin")
    show: true,
    countries: {
        list: []
    },
    id_country: 0,
    appengine_country: false 
}

class CountryChooser {
    oninit(){
        this.get_countries();
    }
    view(vnode) {
        if (!chooser_state.show)
            return;

        let country_chooser = this;

        return  m('div.country-chooser', [
            // m('div.country-chooser__close', {
            //     onclick : function(){
            //         chooser_state.show = false;
            //     }
            // }, m('i.fa.fa-close')),
            m('div.country-chooser__title', trans('country_chooser.title')),
            m('div.country-chooser__content', [
                m('div.country-chooser__text', trans('country_chooser.description')),
                m('div.country-chooser__form', [
                    this.get_country_select(),
                    m ('div.btn', {
                        onclick : function(e) {
                            country_chooser.update_country();
                        }
                    }, trans('common.confirm'))
                ])
            ])
        ]);
    }

    get_country_select() {
        return m('select.country-chooser__form__select', 
            {
                onchange: e => chooser_state.id_country = e.target.value
            },
            [
                m('option', {value: 0}, 'Not selected'),
                chooser_state.countries.list.map(country => {
                    return m('option', { 
                        value: country.id_country, 
                        selected: country.id_country == chooser_state.id_country
                    }, country.name)
                })
            ]
        );
    }

    get_countries() {
        m.request({
            method: "GET",
            url: "/api/countries",
        }).then(function(data) {
            // console.log(data);
            chooser_state.countries.list = data;

            if (chooser_state.appengine_country && chooser_state.appengine_country.length > 0) {
                let sel_country = chooser_state.countries.list.filter(c => c.iso == chooser_state.appengine_country);
                if (sel_country.length > 0) {
                    sel_country = sel_country[0];

                    chooser_state.id_country = sel_country.id_country;
                }
            }
        });
    }

    update_country() {
        // console.log(chooser_state.id_country);

        if (chooser_state.id_country != 0) {
            m.request({
                method: "POST",
                url: "/api/user/country",
                body: {
                    id_country: chooser_state.id_country
                }
            }).then(function(data) {
                chooser_state.show = false;
            });
        }

    }
}

// function init(rootElement) {
function init(rootElement, appengine_country) {

    if (!rootElement) {
        return;
    }

    chooser_state.appengine_country = appengine_country;

    m.mount(rootElement, CountryChooser);
}

export default init;
